import tryRequest, { GetRequestOptions } from './tryRequest'
import {
  PublicGetSpotFeedHistoryCandlesParamsSchema,
  PublicGetSpotFeedHistoryCandlesResponseSchema,
} from './types/public.get_spot_feed_history_candles'

export default async function fetchSpotFeedHistoryCandles(
  params: PublicGetSpotFeedHistoryCandlesParamsSchema,
  options?: GetRequestOptions
): Promise<PublicGetSpotFeedHistoryCandlesResponseSchema> {
  return await tryRequest<
    PublicGetSpotFeedHistoryCandlesParamsSchema,
    PublicGetSpotFeedHistoryCandlesResponseSchema
  >('/public/get_spot_feed_history_candles', params, {
    ...options,
    useGet: true, // NOTE: orderbook wants us to use GET for this route
  })
}
